import type { ChartContext } from "./context";

export function buildCandlestickOption(
  context: ChartContext,
): Record<string, unknown> {
  const { data, translateNode, palette, ct, base } = context;
  const ds = data.datasets[0];
  if (!ds) return base;
  const vals = ds.values as unknown as Array<Record<string, unknown>>;
  const catLabels = vals.map((v) => v.x as string);
  const candlestickFormatter = (
    ps: Array<{ value: number[]; seriesName: string; dataIndex?: number }>,
  ) => {
    const point = ps[0];
    if (!point) return "";
    const name = catLabels[point.dataIndex ?? point.value[0]] ?? "";
    // ECharts prepends the category index to [open, close, low, high].
    const values = point.value.slice(-4);
    return `${translateNode(name)}\n${["Open", "Close", "Low", "High"]
      .map((label, index) => `${translateNode(label)}: ${values[index]}`)
      .join("\n")}`;
  };
  return {
    ...base,
    tooltip: {
      trigger: "axis",
      backgroundColor: ct.bgElevated,
      borderColor: ct.border,
      formatter: candlestickFormatter,
    },
    xAxis: {
      type: "category",
      data: catLabels,
      axisLabel: { color: ct.secondary, formatter: translateNode },
    },
    yAxis: {
      type: "value",
      axisLabel: { color: ct.secondary },
      splitLine: { lineStyle: { color: ct.lightBorder } },
    },
    grid: { left: 60, right: 20, bottom: 40, top: 65, containLabel: true },
    series: [
      {
        type: "candlestick",
        name: ds.label,
        data: vals.map((v) => v.y as number[]),
        itemStyle: {
          color: palette[0],
          color0: palette[1],
          borderColor: palette[0],
          borderColor0: palette[1],
        },
      },
    ],
  };
}
